import { render, staticRenderFns } from "./PostSamplingProjection.vue?vue&type=template&id=10f8fe4d&scoped=true&"
import script from "./PostSamplingProjection.vue?vue&type=script&lang=js&"
export * from "./PostSamplingProjection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8fe4d",
  null
  
)

export default component.exports